/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-skip-forward': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.125 17.5a.625.625 0 01-.625-.625V3.125a.625.625 0 01.938-.544l11.874 6.875a.625.625 0 010 1.088L3.438 17.419a.625.625 0 01-.313.081zM3.75 4.206v11.588l10-5.794-10-5.794zM17.5 2.5h1.25v15H17.5v-15z"/>'
  }
})
